import { EvokeAction } from "react-evoke";
import { AppState } from "../../typings/AppState";
import { AppActions } from "../../typings/AppActions";
import { api } from "../../api";

const getDepartments: EvokeAction<AppState, AppActions> = async store => {
  try {
    const departments = await api.get("departments");
    await store.update(state => {
      state.departments = departments;
    });
  } catch (error) {
    console.log("error", error);
  }
};

const updateDepartment: EvokeAction<AppState, AppActions> = async (
    store,
    id: number,
    values: object
  ) => {
    try {
      const updateDepartment = await api.patch(
        `departments/${id}`,
        {},
        values
      );
      console.log("updateDepartment...",updateDepartment)
  
      // await store.update((state) => {
      //   if (state.departments !== undefined) {
      //     state.departments[updateDepartment.id] = updateDepartment;
      //   }
      // });
    } catch (error) {
      console.log("error", error);
      throw error;
    }
};


export const departmentActions = {
  getDepartments,
  updateDepartment
};
